export default "__VITE_ASSET__DNfz$tf$__"